import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getTemplateGrupos as getTemplateGruposSdk,
  getTemplateGrupo as getTemplateGrupoSdk,
  postTemplateGrupo as postTemplateGrupoSdk,
  putTemplateGrupo as putTemplateGrupoSdk,
} from '@sdk/Conectores/Templates/Grupos';

//Action Types
export const Types = {
  GET_TEMPLATE_GRUPOS: 'GET_TEMPLATE_GRUPOS',
  GET_TEMPLATE_GRUPOS_SUCCESS: 'GET_TEMPLATE_GRUPOS_SUCCESS',
  GET_TEMPLATE_GRUPOS_ERROR: 'GET_TEMPLATE_GRUPOS_ERROR',

  GET_TEMPLATE_GRUPO: 'GET_TEMPLATE_GRUPO',
  GET_TEMPLATE_GRUPO_SUCCESS: 'GET_TEMPLATE_GRUPO_SUCCESS',
  GET_TEMPLATE_GRUPO_ERROR: 'GET_TEMPLATE_GRUPO_ERROR',

  POST_TEMPLATE_GRUPO: 'POST_TEMPLATE_GRUPO',
  POST_TEMPLATE_GRUPO_SUCCESS: 'POST_TEMPLATE_GRUPO_SUCCESS',
  POST_TEMPLATE_GRUPO_ERROR: 'POST_TEMPLATE_GRUPO_ERROR',

  PUT_TEMPLATE_GRUPO: 'PUT_TEMPLATE_GRUPO',
  PUT_TEMPLATE_GRUPO_SUCCESS: 'PUT_TEMPLATE_GRUPO_SUCCESS',
  PUT_TEMPLATE_GRUPO_ERROR: 'PUT_TEMPLATE_GRUPO_ERROR',

  RESET_TEMPLATE_GRUPOS: 'RESET_TEMPLATE_GRUPOS',
};

//Action Creators
export const getTemplateGrupos = () => ({ type: Types.GET_TEMPLATE_GRUPOS });
export const getTemplateGruposSuccess = (data) => ({ type: Types.GET_TEMPLATE_GRUPOS_SUCCESS, data });
export const getTemplateGruposError = (error) => ({ type: Types.GET_TEMPLATE_GRUPOS_ERROR, error });

export const getTemplateGrupo = (id) => ({ type: Types.GET_TEMPLATE_GRUPO, id });
export const getTemplateGrupoSuccess = (data) => ({ type: Types.GET_TEMPLATE_GRUPO_SUCCESS, data });
export const getTemplateGrupoError = (error) => ({ type: Types.GET_TEMPLATE_GRUPO_ERROR, error });

export const postTemplateGrupo = (data) => ({ type: Types.POST_TEMPLATE_GRUPO, data });
export const postTemplateGrupoSuccess = () => ({ type: Types.POST_TEMPLATE_GRUPO_SUCCESS });
export const postTemplateGrupoError = (error) => ({ type: Types.POST_TEMPLATE_GRUPO_ERROR, error });

export const putTemplateGrupo = (data) => ({ type: Types.PUT_TEMPLATE_GRUPO, data });
export const putTemplateGrupoSuccess = () => ({ type: Types.PUT_TEMPLATE_GRUPO_SUCCESS });
export const putTemplateGrupoError = (error) => ({ type: Types.PUT_TEMPLATE_GRUPO_ERROR, error });

export const reset = () => ({ type: Types.RESET_TEMPLATE_GRUPOS });

//saga
function* fetchGetTemplateGrupos(action) {
  try {
    const templateGrupos = yield call(getTemplateGruposSdk);
    yield put(getTemplateGruposSuccess(templateGrupos));
  } catch (err) {
    Notification.error(err.message);
    yield put(getTemplateGruposError(err));
  }
}

function* fetchGetTemplateGrupo(action) {
  try {
    const { id } = action;
    const templateGrupo = yield call(getTemplateGrupoSdk, id);
    yield put(getTemplateGrupoSuccess(templateGrupo));
  } catch (err) {
    Notification.error(err.message);
    yield put(getTemplateGrupoError(err));
  }
}

function* fetchPostTemplateGrupo(action) {
  try {
    const { data } = action;
    yield call(postTemplateGrupoSdk, data);
    yield put(postTemplateGrupoSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(postTemplateGrupoError(err));
  }
}

function* fetchPutTemplateGrupo(action) {
  try {
    const { data } = action;
    yield call(putTemplateGrupoSdk, data);
    yield put(putTemplateGrupoSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(putTemplateGrupoError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_TEMPLATE_GRUPOS, fetchGetTemplateGrupos),
  takeLatest(Types.GET_TEMPLATE_GRUPO, fetchGetTemplateGrupo),
  takeLatest(Types.POST_TEMPLATE_GRUPO, fetchPostTemplateGrupo),
  takeLatest(Types.PUT_TEMPLATE_GRUPO, fetchPutTemplateGrupo),
];

// Reducer
const initialState = Map({
  templateGrupos: List(),
  templateGrupo: {},

  loadingTemplateGrupos: false,
  successTemplateGrupos: false,
  errorTemplateGrupos: false,

  loadingTemplateGrupo: false,
  successTemplateGrupo: false,
  errorTemplateGrupo: false,

  postingTemplateGrupo: false,
  successPostTemplateGrupo: false,
  errorPostTemplateGrupo: false,

  putingTemplateGrupo: false,
  successPutTemplateGrupo: false,
  errorPutTemplateGrupo: false,
});

const handleGetTemplateGrupos = (state, action) => {
  return state.set('loadingTemplateGrupos', false).set('successTemplateGrupos', false).set('errorTemplateGrupos', false);
};

const handleGetTemplateGruposSuccess = (state, action) => {
  const templateGrupos = action.data;

  return state
    .set('templateGrupos', List(templateGrupos))
    .set('loadingTemplateGrupos', false)
    .set('successTemplateGrupos', true)
    .set('errorTemplateGrupos', false);
};

const handleGetTemplateGruposError = (state, action) => {
  return state.set('loadingTemplateGrupos', false).set('successTemplateGrupos', false).set('errorTemplateGrupos', action.error);
};

const handleGetTemplateGrupo = (state, action) => {
  return state.set('loadingTemplateGrupo', false).set('successTemplateGrupo', false).set('errorTemplateGrupo', false);
};

const handleGetTemplateGrupoSuccess = (state, action) => {
  const templateGrupo = action.data[0];
  return state
    .set('templateGrupo', templateGrupo)
    .set('loadingTemplateGrupo', false)
    .set('successTemplateGrupo', true)
    .set('errorTemplateGrupo', false);
};

const handleGetTemplateGrupoError = (state, action) => {
  return state.set('loadingTemplateGrupo', false).set('successTemplateGrupo', false).set('errorTemplateGrupo', action.error);
};

const handlePostTemplateGrupo = (state, action) => {
  return state.set('postingTemplateGrupo', false).set('successPostTemplateGrupo', false).set('errorPostTemplateGrupo', false);
};

const handlePostTemplateGrupoSuccess = (state, action) => {
  return state.set('postingTemplateGrupo', false).set('successPostTemplateGrupo', true).set('errorPostTemplateGrupo', false);
};

const handlePostTemplateGrupoError = (state, action) => {
  return state.set('postingTemplateGrupo', false).set('successPostTemplateGrupo', false).set('errorPostTemplateGrupo', action.error);
};

const handlePutTemplateGrupo = (state, action) => {
  return state.set('putingTemplateGrupo', false).set('successPutTemplateGrupo', false).set('errorPutTemplateGrupo', false);
};

const handlePutTemplateGrupoSuccess = (state, action) => {
  return state.set('putingTemplateGrupo', false).set('successPutTemplateGrupo', true).set('errorPutTemplateGrupo', false);
};

const handlePutTemplateGrupoError = (state, action) => {
  return state.set('putingTemplateGrupo', false).set('successPutTemplateGrupo', false).set('errorPutTemplateGrupo', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_TEMPLATE_GRUPOS:
      return handleGetTemplateGrupos(state, action);
    case Types.GET_TEMPLATE_GRUPOS_SUCCESS:
      return handleGetTemplateGruposSuccess(state, action);
    case Types.GET_TEMPLATE_GRUPOS_ERROR:
      return handleGetTemplateGruposError(state, action);

    case Types.GET_TEMPLATE_GRUPO:
      return handleGetTemplateGrupo(state, action);
    case Types.GET_TEMPLATE_GRUPO_SUCCESS:
      return handleGetTemplateGrupoSuccess(state, action);
    case Types.GET_TEMPLATE_GRUPO_ERROR:
      return handleGetTemplateGrupoError(state, action);

    case Types.POST_TEMPLATE_GRUPO:
      return handlePostTemplateGrupo(state, action);
    case Types.POST_TEMPLATE_GRUPO_SUCCESS:
      return handlePostTemplateGrupoSuccess(state, action);
    case Types.POST_TEMPLATE_GRUPO_ERROR:
      return handlePostTemplateGrupoError(state, action);

    case Types.PUT_TEMPLATE_GRUPO:
      return handlePutTemplateGrupo(state, action);
    case Types.PUT_TEMPLATE_GRUPO_SUCCESS:
      return handlePutTemplateGrupoSuccess(state, action);
    case Types.PUT_TEMPLATE_GRUPO_ERROR:
      return handlePutTemplateGrupoError(state, action);

    case Types.RESET_TEMPLATE_GRUPOS:
      return handleReset(state, action);

    default:
      return state;
  }
}
